import React from 'react';
import Step from './Step';
import Button from '../../common/Button';
import PricingTable from './pricing/PricingTable';
import StepModel from '../../../model/configurator/StepModel';
import Summary from './pricing/summary';
import TypingTester from '../../../TypingTester';
import {hideSummary} from './helpers/pricingHelpers';
import ImportFile from '../../common/ImportFile'
import Modal from '@lib/components/common/Modal';
import store from '@lib/store/configuration';
import saveBlobAsFile from '../../utils/saveBlobAsFile';
import Loader from '../../common/Loader';

export default class StepPricing extends Step {

    _stepClassName = 'configuration-editor-step-pricing';

    constructor(props) {
        super(props)
        this.typingTester = new TypingTester(200)
        this.summaryRef = React.createRef()
        this.tableRef = React.createRef()
        this.state = {
            model: this.stepModel.model,
            importModalIsOpen: false,
            isFileToUpload: false,
            duringExport: false,
            duringImport: false,
            isLoading: false,
            showExcludedModules: false
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            model: nextProps.model.pricing
        })
    }

    stepAboutToBecomeVisible() {
        let summary = this.summaryRef.current
        let table = this.tableRef.current

        hideSummary(summary, this.stepModel.model.items)

        if (summary && table) {
            let finalPriceHeader = table.querySelectorAll('th[slug="Final"]')[0]
            // Wait for React to render the component.
            setTimeout(() => {

                // Now wait for the animation to end, because it changes the dimensions.
                setTimeout(() => {
                    summary.style.position = 'relative'
                    if (this.stepModel.model.items.columns.some(x => x.slug == 'Margin' && x.visible)) {
                        summary.style.left = (finalPriceHeader.offsetLeft - table.offsetLeft) + 'px'
                    } else {
                        summary.style.marginLeft = 'auto';
                        summary.style.marginRight = 0;
                    }

                    $(summary).animate({'opacity': 1}, 100)
                }, 200)
            })
        }
    }

    onAddModuleButtonClick = () => {
        let rows = this.state.model.items.items

        rows.push({
            id: String(Math.round(Math.random() * 1000)),
            isFromModel: false,
            quantity: 1,
            canAddAndEditRows: this.stepModel.model.canAddAndEditRows,
            final: '0.00',
            margin: '0.00',
            marginPercentage: '0'
        })

        this.scheduleRowsUpdate(rows)
    }

    onImportXlsButtonClick = () => {
        this.setImportModalIsOpen(true);
    }

    onExportModulesButtonClick = () => {
        const doExport = () => {
            let model = store.getTransformedFormModel();

            let data = new FormData();
            data.append('file', this.state.addModuleFile);
            data.append('model', JSON.stringify(model));//form data needs this

            this.stepModel.editor.configurationAPIService
                .exportModuleXls(model)
                .then(response => {
                    saveBlobAsFile(response);
                    this.setState({
                        duringExport: false
                    })
                });
        }


        this.setState({
            duringExport: true
        }, () => {
            doExport();

        });

    }

    onConfigurePricingEvent = (items, onStart, onStop) => {
        let payload = {
            configuration: store.getTransformedFormModel(),
            items
        };

        const func = () => {
            this.stepModel.editor.configurationAPIService.configurePricing(payload).then(response => {
                this.configurationAPIServiceSuccess(response);
                onStop();
            });
        }

        onStart(func)
    }

    configurationAPIServiceSuccess(response) {
        store.formModel.pricing = response.data.pricing;
    }

    setImportModalIsOpen = (value) => {
        if (!value) {
            this.setState({isFileToUpload: false, addModuleFile: undefined})
        }
        this.setState({importModalIsOpen: value});

    }

    fileUploaded = (file) => {
        let isFile = false;
        if (file)
            isFile = true;

        this.setState({isFileToUpload: isFile})

        this.setState({addModuleFile: file})
    }

    onImportButtonClick = () => {
        const doImport = () => {
            let model = store.getTransformedFormModel();

            let data = new FormData();
            data.append('file', this.state.addModuleFile);
            data.append('model', JSON.stringify(model));//form data needs this
            this.stepModel.editor.configurationAPIService
                .importModuleXls(data, model)
                .then(result => {
                    if (result.status == 200) {
                        this.props.onModelResponseReceived(result);
                    }
                    this.setImportModalIsOpen(false);
                    this.setState({
                        duringImport: false
                    })
                });
        }

        this.setState({
            duringImport: true
        }, () => {
            doImport();
        })
    }

    updatePricingData = (data) => {
        let model = this.state.model;
        model.total.value = data.total;
        model.totalValue = data.totalValue;
        model.totalMargin.value = data.totalMargin;
        model.discountedTotal.value = data.discountedTotal;
        model.factoryTotal.value = data.factoryTotal;
        this.setState({rows: data.items});
    }

    renderImportXlsModal() {
        let importDisabled = !this.state.isFileToUpload
        return (
            <Modal isOpen={this.state.importModalIsOpen} onClose={() => this.setImportModalIsOpen(false)}>
                <Modal.Header>{__('Import modules from XLS')}</Modal.Header>
                <Modal.Body>
                    {this.state.duringImport && <Loader fillContainer={true}/>}
                    <ImportFile onFileUploaded={(f) => this.fileUploaded(f)}></ImportFile>
                </Modal.Body>
                <Modal.Footer>
                    <button className="button-v2 button-size-default button-theme-border-only button-color-default"
                            onClick={() => this.setImportModalIsOpen(false)}>{__('Cancel')}</button>
                    <button
                        className={"button-v2 button-size-default button-theme-border-only" + (importDisabled ? " button-disabled" : " button-color-default")}
                        onClick={this.onImportButtonClick} disabled={importDisabled}>
                        {__('Import')}
                    </button>
                </Modal.Footer>
            </Modal>
        )
    }

    onRemoveSelectedButtonClick = () => {
        this.scheduleRowsUpdate(this.state.model.items.items.filter(x => !x.isSelected))
        this.props.onFormModelChange();
    }

    pricingColumns = {
        price: "Price",
        quantity: "Quantity",
        factoryCost: "FactoryCost"
    }

    tableVisible = () => this.stepModel.model.items.visible

    onRowChange = (row, propertySlug, nextValue, focus, onStart, onStop) => {
        let newModel = Object.assign({}, this.state.model);
        newModel.items.items.find(x => x.id === row.id)[propertySlug.firstCharacterLowerCase()] = nextValue;

        if (!focus) {
            this.onConfigurePricingEvent(newModel.items.items, onStart, onStop);
        } else {
            this.setState({
                model: newModel
            })
        }
    }

    loadPricingWithNewComponent = (row, column, value, onStart, onStop) => {
        let model = Object.assign({}, this.state.model);
        model.items.items.find(x => x.id === row.id)[column.slug.firstCharacterLowerCase()] = value;
        this.onConfigurePricingEvent(model.items.items, onStart, onStop);
    }

    onRowCheckboxChange = (row, e) => {
        this.state.model.items.items
            .filter(x => x.id === row.id)
            .forEach(x => x.isSelected = !x.isSelected)

        this.scheduleRowsUpdate(this.state.model.items.items)
    }

    scheduleRowsUpdate(nextRows) {
        let newModel = Object.assign({}, this.state.model);
        newModel.items.items = nextRows;
        this.setState({
            model: newModel
        })
    }

    anyRowsSelected() {
        return this.state.model.items.items.filter(x => x.isSelected).length > 0
    }

    getRows(model) {
        var items = model.items.items.toJS();
        return items.filter(x => {
            var vm = model.items.itemsViewModel.find(ivm => ivm.moduleNumber.value === x.moduleNumber);
            return vm === undefined ? true : vm.visible;
        })
    }

    renderTable(model) {
        return (
            <React.Fragment>
                <PricingTable
                    stepClassName={this._stepClassName}
                    canAddAndEditRows={model.canAddAndEditRows}
                    columns={model.items.columns.toJS().filter(x => x.visible)}
                    rows={this.getRows(model)}
                    onRowChange={this.onRowChange}
                    onRowCheckboxChange={this.onRowCheckboxChange}
                    tref={this.tableRef}
                    marketSymbol={this.props.model.generalInformation.marketSymbol.value}
                    productTypeSymbol={this.props.model.unitType.productTypeSymbol.value}
                    loadPricingWithNewComponent={this.loadPricingWithNewComponent}
                />

                <div className="action-buttons --bottom">
                    {this.renderAddModuleButton(model)}
                    <Button
                        theme={Button.Theme.BorderOnly}
                        disabled={this.anyRowsSelected() === false}
                        onClick={this.onRemoveSelectedButtonClick}
                    >
                        {__('Remove')}
                    </Button>
                </div>

            </React.Fragment>
        )
    }

    renderBody(model) {
        model = this.state.model;

        if (model.items.columns.length === 0) {
            return <React.Fragment></React.Fragment>;
        }

        return (
            <div className={this.tableVisible() ? '' : '--only-configuration-editor-pricing-summary'}>
                <div className="action-buttons">
                    {this.renderImportXlsModal()}
                    {this.renderAddModuleButton(model)}
                    {this.renderImportFromExcelButton(model)}
                    {this.renderExportModulesExcelButton(model)}
                </div>
                <div>
                    {model.items.visible && this.renderShowExcludedModules()}
                    {model.items.visible && this.renderTable(model)}
                </div>
                <Summary sref={this.summaryRef} model={model}/>
                {this.state.isLoading && <Loader fillContainer={true}/>}
            </div>
        )
    }

    renderAddModuleButton(model) {
        if (model.canAddAndEditRows && model.items.visible) {
            return <Button id="add-module" theme={Button.Theme.BorderOnly}
                           onClick={this.onAddModuleButtonClick}>{__('Add module')}</Button>
        }
    }

    renderImportFromExcelButton(model) {
        if (model.canImport && model.items.visible) {
            return <Button theme={Button.Theme.BorderOnly}
                           onClick={this.onImportXlsButtonClick}>{__('Import XLS')}</Button>
        }
    }

    renderExportModulesExcelButton(model) {
        if (model.items.visible) {
            return <Button processing={this.state.duringExport} theme={Button.Theme.BorderOnly}
                           onClick={this.onExportModulesButtonClick}>{__('Export XLS')}</Button>
        }
    }

    renderShowExcludedModules() {
        return (
            <div className="show-excluded-modules">
                <input type="checkbox" id="show-excluded-modules" onChange={this.onShowExcludedModulesClick}></input>
                <label htmlFor="show-excluded-modules">{__('Show excluded modules')}</label>
            </div>
        )
    }

    onShowExcludedModulesClick = () => {
        this.setState(prev => ({
            showExcludedModules: !prev.showExcludedModules,
            isLoading: true
        }), () => {
            store.setShowExcludedModules(this.state.showExcludedModules);
            var model = store.getTransformedFormModel();
            let payload = {
                configuration: store.getTransformedFormModel(),
                items: model.pricing.items
            };
            this.stepModel.editor.configurationAPIService.configurePricing(payload).then(response => {
                this.configurationAPIServiceSuccess(response);
                this.setState({
                    isLoading: false
                })
            });
        })
    }

    static getStepModel(model) {
        return new StepModel('pricing', model.pricing)
    }
}
